document.addEventListener("focusin", (event) => {
  if (!event.target.closest(".header-search")) return;

  document.querySelectorAll(".ef-nav details[open]").forEach((menu) => {
    menu.removeAttribute("open");
    const summary = menu.querySelector(":scope > summary");
    if (summary) summary.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("click", (event) => {
  if (!event.target.closest(".search-drawer-opener-button")) return;

  document.querySelectorAll(".ef-nav details[open]").forEach((menu) => {
    menu.removeAttribute("open");
    const summary = menu.querySelector(":scope > summary");
    if (summary) summary.setAttribute("aria-expanded", "false");
  });
});
